import React from 'react';
import { FileTextIcon, UsersIcon, StarIcon, HeartIcon } from 'lucide-react';
export function SocialProof() {
  return <section className="bg-white border-b border-gray-200 pb-12" data-id="element-268">
      {/* Banner */}
      <div className="bg-green-50 py-4 px-4 flex flex-col sm:flex-row items-center justify-center gap-4 mb-10" data-id="element-269">
        <div className="flex -space-x-3" data-id="element-270">
          {[{
          bg: 'bg-blue-500',
          init: 'MG'
        }, {
          bg: 'bg-red-500',
          init: 'CL'
        }, {
          bg: 'bg-yellow-500',
          init: 'LF'
        }, {
          bg: 'bg-purple-500',
          init: 'AR'
        }, {
          bg: 'bg-pink-500',
          init: 'PM'
        }].map((avatar, i) => <div key={i} className={`w-10 h-10 rounded-full border-2 border-white flex items-center justify-center text-white text-xs font-bold ${avatar.bg}`} data-id="element-271">
              {avatar.init}
            </div>)}
        </div>
        <p className="text-green-800 font-medium text-center sm:text-left" data-id="element-272">
          Già scelto da <span className="font-bold" data-id="element-273">2.847+</span> appassionati
          di cucina in tutta Italia
        </p>
      </div>

      {/* Stats Grid */}
      <div className="max-w-6xl mx-auto px-4" data-id="element-274">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-275">
          <div className="flex items-center gap-4 p-4 rounded-2xl bg-blue-50" data-id="element-276">
            <div className="p-3 bg-blue-100 rounded-xl text-blue-600" data-id="element-277">
              <FileTextIcon className="w-6 h-6" data-id="element-278" />
            </div>
            <div data-id="element-279">
              <p className="font-bold text-xl text-gray-900" data-id="element-280">50+</p>
              <p className="text-sm text-gray-600" data-id="element-281">Ricette testate</p>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 rounded-2xl bg-orange-50" data-id="element-282">
            <div className="p-3 bg-orange-100 rounded-xl text-orange-600" data-id="element-283">
              <UsersIcon className="w-6 h-6" data-id="element-284" />
            </div>
            <div data-id="element-285">
              <p className="font-bold text-xl text-gray-900" data-id="element-286">2.8k+</p>
              <p className="text-sm text-gray-600" data-id="element-287">Clienti soddisfatti</p>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 rounded-2xl bg-green-50" data-id="element-288">
            <div className="p-3 bg-green-100 rounded-xl text-green-600" data-id="element-289">
              <StarIcon className="w-6 h-6 fill-current" data-id="element-290" />
            </div>
            <div data-id="element-291">
              <p className="font-bold text-xl text-gray-900" data-id="element-292">4.9/5</p>
              <p className="text-sm text-gray-600" data-id="element-293">Valutazione media</p>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 rounded-2xl bg-red-50" data-id="element-294">
            <div className="p-3 bg-red-100 rounded-xl text-red-600" data-id="element-295">
              <HeartIcon className="w-6 h-6 fill-current" data-id="element-296" />
            </div>
            <div data-id="element-297">
              <p className="font-bold text-xl text-gray-900" data-id="element-298">100%</p>
              <p className="text-sm text-gray-600" data-id="element-299">Soddisfazione</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}